import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { AboutMeComponent } from './pages/aboutMe/aboutMe.component';
import { SkillsComponent } from './pages/skills/skills.component';
import { ExperienceComponent } from './pages/experience/experience.component';
import { ProjectsComponent } from './pages/projects/projects.component';
import { GalleryComponent } from './pages/gallery/gallery.component';
import { ClientsComponent } from './pages/clients/clients.component';
import { ContactComponent } from './pages/contact/contact.component';

const routes: Routes = [
  { path: '', component: HomeComponent, pathMatch: 'full', data: { animation: 'HomePage' } },
  { path: 'home', redirectTo: '', pathMatch: 'full' },
  { path: 'abautMe', component: AboutMeComponent, data: { animation: 'AboutPage' } },
  { path: 'nosotros', redirectTo: 'abautMe' },
  { path: 'skills', component: SkillsComponent, data: { animation: 'SkillsPage' } },
  { path: 'servicios', redirectTo: 'skills' },
  { path: 'experience', component: ExperienceComponent, data: { animation: 'ExperiencePage' } },
  { path: 'experiencia', redirectTo: 'experience' },
  { path: 'projects', component: ProjectsComponent, data: { animation: 'ProjectsPage' } },
  { path: 'proyectos', redirectTo: 'projects' },
  { path: 'gallery', component: GalleryComponent, data: { animation: 'GalleryPage' } },
  { path: 'certificaciones', redirectTo: 'gallery' },
  { path: 'clients', component: ClientsComponent, data: { animation: 'ClientsPage' } },
  { path: 'clientes', redirectTo: 'clients' },
  { path: 'contact', component: ContactComponent, data: { animation: 'ContactPage' } },
  { path: 'contacto', redirectTo: 'contact' },
  { path: '**', redirectTo: '' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { 
    scrollPositionRestoration: 'top',
    anchorScrolling: 'enabled'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
